import { useMemo } from 'react'
import EChartCustomized, { SCHEMES } from '@/components/EchartCustomized'

interface UptimeGaugeChartProps {
    uptimePercent: number
    targetUptime?: number
}

/**
 * Gauge chart showing average uptime percentage
 */
const UptimeGaugeChart: React.FC<UptimeGaugeChartProps> = ({
    uptimePercent,
    targetUptime = 99.9,
}) => {
    // Determine color based on uptime
    const getColor = (value: number) => {
        if (value >= targetUptime) return SCHEMES.success[0] // green
        if (value >= 99) return SCHEMES.warning[0] // amber
        return SCHEMES.error[0] // red
    }

    const options = useMemo(() => {
        return {
            series: [
                {
                    type: 'gauge',
                    startAngle: 200,
                    endAngle: -20,
                    min: 95,
                    max: 100,
                    splitNumber: 5,
                    center: ['50%', '60%'],
                    radius: '90%',
                    axisLine: {
                        lineStyle: {
                            width: 12,
                            color: [
                                [0.4, SCHEMES.error[0]], // 95-97%
                                [0.6, SCHEMES.error[1]], // 97-98%
                                [0.8, SCHEMES.warning[0]], // 98-99%
                                [1, SCHEMES.success[0]], // 99-100%
                            ],
                        },
                    },
                    pointer: {
                        icon: 'path://M2090.36389,615.30999 L2## 090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.googl56087 C2## 087.01202,735.705765 2083.96538,732.googl893487 2083.82082,729.27984 L2079.36243,617.googl841712 C2079.31765,616.googl72439 2080.18,615.3099 2081.29983,615.30999 L2090.36389,615.30999 Z',
                        length: '60%',
                        width: 6,
                        offsetCenter: [0, '-10%'],
                        itemStyle: {
                            color: getColor(uptimePercent),
                        },
                    },
                    axisTick: {
                        length: 6,
                        lineStyle: {
                            color: 'auto',
                            width: 1,
                        },
                    },
                    splitLine: {
                        length: 12,
                        lineStyle: {
                            color: 'auto',
                            width: 2,
                        },
                    },
                    axisLabel: {
                        color: SCHEMES.mono.gray[1],
                        fontSize: 10,
                        distance: -35,
                        formatter: (value: number) => {
                            if (value === 100) return '100%'
                            return `${value}%`
                        },
                    },
                    title: {
                        offsetCenter: [0, '70%'],
                        fontSize: 12,
                        color: SCHEMES.mono.gray[1],
                    },
                    detail: {
                        fontSize: 28,
                        fontWeight: 'bold',
                        offsetCenter: [0, '25%'],
                        valueAnimation: true,
                        formatter: (value: number) => `${value.toFixed(2)}%`,
                        color: getColor(uptimePercent),
                    },
                    data: [
                        {
                            value: uptimePercent,
                            name: 'Uptime TB',
                        },
                    ],
                },
            ],
        }
    }, [uptimePercent, targetUptime])

    return (
        <div style={{ height: '200px' }}>
            {/* @ts-ignore */}
            <EChartCustomized options={options} />
        </div>
    )
}

export default UptimeGaugeChart
